export default "__VITE_ASSET__DgeyJwIp__"